import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {TooltipOverflowCondition} from '../../../../../../libs/shared/ui/src/components/tooltips/tooltipOverflowCondition';

/*
 * Props.
 */

interface ConversationHeaderPillTextProps {
  className?: string;
  children: string;
}

/*
 * Style.
 */

const StyledTextDiv = styled.div`
  max-width: 20ch;
`;

/*
 * Component.
 */

export const ConversationHeaderPillText: FC<PropsWithChildren<ConversationHeaderPillTextProps>> = (props) => (
  <StyledTextDiv className={props.className}>
    <TooltipOverflowCondition>{props.children}</TooltipOverflowCondition>
  </StyledTextDiv>
);
